export default "__VITE_ASSET__DXcWiJHr__"